import { getRegionsByColumns } from './getRegionsByColumns';
import { SPECIAL_REGIONS } from '../../../../constants/geo';
import { IRegion } from '../../../../types/regions';
import { isMoscowAndMoscowArea, isSPBAndLo } from '../../../../utils/geo';

interface IGetRegionsByAlphabetResult {
  mainRegions: IRegion[];
  regionByColumns: IRegion[][][];
}

export function getRegionsStepData(allRegions: IRegion[]): IGetRegionsByAlphabetResult {
  const specialRegionIds = SPECIAL_REGIONS.map(region => region.id);
  const regions = allRegions.filter(region => region.parentId == null || specialRegionIds.includes(region.id));

  const mainRegions: IRegion[] = [];
  const letters: string[] = [];
  const regionsByAlphabet: Record<string, IRegion[]> = {};

  regions.forEach((region: IRegion) => {
    const { name } = region;

    if (isMoscowAndMoscowArea(region) || isSPBAndLo(region)) {
      mainRegions.push(region);
    } else {
      if (!regionsByAlphabet[name[0]]) {
        regionsByAlphabet[name[0]] = [];
        letters.push(name[0]);
      }

      regionsByAlphabet[name[0]].push(region);
    }
  });

  letters.sort();

  const regionByColumns = getRegionsByColumns(letters, regionsByAlphabet, regions.length - mainRegions.length);

  return {
    mainRegions,
    regionByColumns,
  };
}
